import React, { Fragment, useState } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import { CircularProgress, Grid, IconButton, Tooltip } from "@mui/material";

import {
  HeadingEighteen,
  TextFourteenBlack,
  colors,
} from "../../css components/Style";
import { TextAvatar } from "../../../components";
import { useAxios, useAlert } from "../../../hooks";
import MuiTable from "../../../components/MuiTable";
import convertDateTimeUTC from "./../../../utils/convertUTC";

const Icon = styled(IconButton)`
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  &:hover {
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

export default function List({ usersList, setUserStatus, loading }) {
  const axios = useAxios();
  const { alert } = useAlert();
  const dispatch = useDispatch();
  const [emailLoading, setEmailLoading] = useState({});

  let columns = [
    { name: "", label: "" },
    { name: "user", label: "Display Name" },
    {
      name: "email",
      label: "Email",
    },

    {
      name: "created_at",
      label: "Registration Date",
    },

    {
      name: "is_email_verified",
      label: "Email Verification",
    },

    { name: "account_status", label: "Admin Verification" },

    {
      name: "is_brand_created",
      label: "Brand Created",
    },

    {
      name: "resend_email",
      label: "Resend Email",
    },
  ];
  function handleResendEmail(emailId, userId, platformID) {
    setEmailLoading((prev) => ({
      ...prev,
      [userId]: true,
    }));
    axios({
      url: "/send/unverified/users/email",
      method: "POST",
      data: { email: emailId, platform_id: platformID },
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        setEmailLoading((prev) => ({
          ...prev,
          [userId]: false,
        }));
        dispatch(alert({ type: "success", message: response.data }));
      } else {
        setEmailLoading((prev) => ({
          ...prev,
          [userId]: false,
        }));
      }
    });
  }

  const renderCell = (col, value, row) => {
    if (col.name === "") {
      return (
        <TextAvatar
          userName={row.given_name.replace(/_/g, " ") + " " + row.family_name}
        />
      );
    }

    if (col.name === "email") {
      return value?.length > 20 ? value?.substr(0, 20) + "..." : value || "-";
    }

    if (col.name === "created_at") {
      return convertDateTimeUTC(value);
    }

    if (col.name === "user") {
      let name = row.given_name.replace(/_/g, " ") + " " + row.family_name;
      return (
        <Fragment>
          <HeadingEighteen>
            {name.length > 20 ? name.substring(0, 20) + "..." : name}
          </HeadingEighteen>

          <TextFourteenBlack>
            {row.display_name.length > 20
              ? row.display_name.substr(0, 20) + "..."
              : row.display_name}
          </TextFourteenBlack>
        </Fragment>
      );
    }

    if (col.name === "is_email_verified") {
      return !value ? (
        <CloseIcon
          sx={{
            color: colors.error,
            borderRadius: "5px",
            border: "3px solid",
            fontSize: "x-large",
            marginLeft: "45px",
            marginTop: "5px",
          }}
        />
      ) : (
        value && (
          <CheckIcon
            sx={{
              color: colors.green,
              borderRadius: "5px",
              border: "3px solid",
              fontSize: "x-large",
              marginLeft: "45px",
              marginTop: "5px",
            }}
          />
        )
      );
    }

    if (col.name === "is_brand_created") {
      return !value ? (
        <CloseIcon
          sx={{
            color: colors.error,
            borderRadius: "5px",
            border: "3px solid",
            fontSize: "x-large",
            marginLeft: "45px",
            marginTop: "5px",
          }}
        />
      ) : (
        value && (
          <CheckIcon
            sx={{
              color: colors.green,
              borderRadius: "5px",
              border: "3px solid",
              fontSize: "x-large",
              marginLeft: "45px",
              marginTop: "5px",
            }}
          />
        )
      );
    }

    if (col.name === "resend_email") {
      return (
        !row.is_email_verified && (
          <div style={{ display: "flex" }}>
            <Tooltip title="Resend Email">
              {emailLoading[row.user_id] ? (
                <CircularProgress />
              ) : (
                <Icon
                  style={{
                    border: `1px solid ${colors.green}`,
                    color: colors.green,
                  }}
                >
                  <ForwardToInboxIcon
                    style={{
                      color: colors.green,
                      height: "20px",
                      width: "20px",
                    }}
                    onClick={() =>
                      handleResendEmail(row.email, row.user_id, row.platform_id)
                    }
                  />
                </Icon>
              )}
            </Tooltip>
          </div>
        )
      );
    }
  };

  return (
    <Grid container spacing={8}>
      <Grid size={12} />
      <Grid size={12}>
        <MuiTable
          loading={loading}
          columns={columns}
          renderCell={renderCell}
          data={usersList}
        />
      </Grid>
    </Grid>
  );
}
